"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _material = require("@mui/material");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _wouter = require("wouter");
var _Style = require("../../style/Style");
var _form = require("../../components/form");
var _common = require("../../store/common");
var _lesson = require("../../store/lesson");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const App = props => {
  const [, setLocation] = (0, _wouter.useLocation)();
  const {
    setToastOpen,
    setToastText,
    setIsLoading,
    setLoadingMessage
  } = (0, _common.useCommonStore)();
  const {
    setCurrentLesson,
    checkCurrentLesson,
    addCurrentLesson,
    updateCurrentLesson,
    setCurrentLessonById,
    initCurrentLesson,
    setSubmitting,
    currentLesson,
    errors,
    submitting
  } = (0, _lesson.useLessonStore)();
  const [isUpdate] = (0, _react.useState)(!!props.id);
  const detailRef = (0, _react.useRef)(null);
  const csvFileRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    setSubmitting(false);
    (async () => {
      if (!props.id) {
        if (!props.courseId) {
          setLocation('/course');
          return;
        }
        initCurrentLesson(props.courseId);
        return;
      }
      setIsLoading(true);
      await setCurrentLessonById(props.id);
      setIsLoading(false);
    })();
  }, []);
  const onUploadStateChanged = snapshot => {
    setLoadingMessage('教材動画をアップロード中...(' + Math.floor(snapshot.bytesTransferred / snapshot.totalBytes * 100) + '%)');
  };
  const onLoadingTextChanged = text => {
    setLoadingMessage(text);
  };
  const uploadExamQuestionsCSV = async () => {};
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
    container: true,
    ...stylex.props(_Style.wrapper.main),
    spacing: 4,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        ...stylex.props(_Style.buttonStyle.secondary),
        onClick: () => {
          setLocation('/course/detail/' + props.courseId);
        },
        children: "\uFF1C\u623B\u308B"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      container: true,
      ...stylex.props(_Style.wrapper.mainTitle),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ...stylex.props(_Style.textStyle.h1),
        children: "\u6559\u6750\u8FFD\u52A0"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
      container: true,
      spacing: 2,
      direction: 'column',
      ...stylex.props(_Style.wrapper.stretchW),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldInput, {
        label: "\u6559\u6750\u540D",
        type: "text",
        value: currentLesson.name,
        errorText: errors.name,
        placeholder: '教材の名前を入力してください(他の教材と重複不可)',
        onChange: event => {
          setCurrentLesson({
            name: event.target.value
          });
        },
        onEnterKey: () => {
          var _detailRef$current;
          (_detailRef$current = detailRef.current) === null || _detailRef$current === void 0 ? void 0 : _detailRef$current.focus();
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldTextArea, {
        label: "\u6559\u6750\u6982\u8981",
        type: "textarea",
        value: currentLesson.detail,
        onChange: event => {
          setCurrentLesson({
            detail: event.target.value
          });
        },
        errorText: errors.detail,
        placeholder: '教材の概要を入力してください'
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldImage, {
        label: "\u30B5\u30E0\u30CD\u30A4\u30EB\u753B\u50CF",
        type: "file",
        previewUrl: currentLesson.thumbnailPreviewUrl,
        onChange: event => {
          const target = event.target;
          if (!target.files || target.files.length === 0) return;
          const file = target.files[0];
          if (!file) return;
          currentLesson.thumbnailFile = file;
          setCurrentLesson({
            thumbnailFile: file
          });
        },
        errorText: errors.thumbnailFile
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldVideo, {
        label: "\u6559\u6750\u52D5\u753B",
        type: "file",
        previewUrl: currentLesson.videoPreviewUrl,
        onChange: event => {
          const target = event.target;
          if (!target.files || target.files.length === 0) return;
          const file = target.files[0];
          if (!file) return;
          setCurrentLesson({
            videoFile: file
          });
        },
        onGetDuration: duration => {
          setCurrentLesson({
            duration: duration
          });
        },
        errorText: errors.videoFile
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldTextFile, {
        label: "\u30C6\u30B9\u30C8\u554F\u984CCSV\u30D5\u30A1\u30A4\u30EB",
        onChangeValue: value => {
          console.log(value);
          setCurrentLesson({
            examQuestionCSV: value
          });
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        ...stylex.props(_Style.buttonStyle.primary),
        disabled: submitting,
        onClick: async () => {
          setIsLoading(true);
          if (!(await checkCurrentLesson(isUpdate))) {
            setIsLoading(false);
            return;
          }
          setIsLoading(false);
          if (!window.confirm((isUpdate ? '教材内容を変更' : '教材を追加') + 'しますか？')) {
            return;
          }
          setIsLoading(true);
          const result = isUpdate ? await updateCurrentLesson(onLoadingTextChanged, onUploadStateChanged) : await addCurrentLesson(onLoadingTextChanged, onUploadStateChanged);
          if (!result) {
            setIsLoading(false);
            return;
          }
          setToastOpen(true);
          setToastText(isUpdate ? '教材内容を変更しました' : '教材を追加しました');
          setLocation('/course/detail/' + props.courseId);
          setIsLoading(false);
          return;
        },
        children: submitting ? isUpdate ? '教材内容変更中...' : '教材追加中...' : isUpdate ? '教材内容を変更する' : '教材追加する'
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
        minHeight: 48,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          ...stylex.props(_Style.textStyle.error),
          children: errors.submit
        })
      })]
    })]
  });
};
var _default = exports.default = App;